import React from 'react';
import MenuManagementContextPropsType from './MenuManagementContextPropTypes';
import menuConfig from './menuConfig';

export default React.createContext<MenuManagementContextPropsType>(menuConfig);
